import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BotConfigProvider } from '../../../context/BotConfigContext';
import useAuthService from '../../../services/auth/authService';
import useLayoutService from '../../../services/layout/layoutService';
import Chat from '../../chat/Chat';
import classes from './ChatArea.module.css';

export default function ChatArea({ configWithUrl }) {
  const authService = useAuthService();
  const authState = useSelector((state) => state.auth);
  const { texts } = useSelector((state) => state.translate);

  useLayoutService();

  useEffect(() => {
    authService.auth();
  }, []);

  useEffect(() => {
    if (authState.isAuth !== false || window.config?.autoLogin !== true) return;
    authService.accessRequest();
  }, [authState.isAuth]);

  if (!authState.isAuth) {
    return (
      <div className={classes.AuthPrompt}>
        <span className={classes.AuthText}>{texts.nonAuthText}</span>
        <button className={classes.AuthButton} onClick={() => authService.accessRequest()}>
          {texts.grantPermission}
        </button>
      </div>
    );
  }

  if (!configWithUrl) {
    return <div className={classes.Loading} />;
  }

  return (
    <BotConfigProvider value={configWithUrl}>
      <Chat />
    </BotConfigProvider>
  );
}
